module.exports = __webpack_public_path__ + "img/hcdl_gallery2.4d1ea692.jpg";